<template>
  <div class="services">
    <img :src="backgroundTop" class="academy__pennellata-top">
    <HeroText
      :heroH1="''"
      :heroH2="currentPage.fields.title"
      :heroP="currentPage.fields.intro"
      :internalPage="true"
    />
    <!-- Slides -->
    <InternalPageSlides 
      v-if="typeof currentPage.fields.layoutedContents !== 'undefined'"
      :slidesArray="currentPage.fields.layoutedContents"
      :bgImage="backgroundHrz"
    />
    <FooterArea/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import HeroText from '@/components/HeroText/HeroText.vue'
import InternalPageSlides from '@/components/InternalPageSlides/InternalPageSlides.vue'
import FooterArea from '@/components/FooterArea/FooterArea.vue'
import matchMedia from '@/mixins/matchMedia.js'

export default {
  name: 'Services',
  mixins: [matchMedia],
  components: {
    HeroText,
    InternalPageSlides,
    FooterArea
  },
  props: {
    currentPage: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    backgroundTop: require('@/assets/services/pennellata-top.jpg'),
    backgroundHrz: require('@/assets/services/pennellata-horizontal.jpg')
  }),
  methods: {
    $_discoverAssortment () {
      this.$emit('open-categories')
    }
  }
}
</script>

<style lang="scss">
  .services{
    background-color: #FFF3F0;
  }
</style>